import React from "react";
import { map, findIndex } from "lodash";

const getListOfValues = preference => {
  try {
    if (preference.length === 0) {
      return `Doesn't Matter`;
    } else {
      let result = "";
      map(preference, (item, index) => {
        if (index === 0) {
          result += item.label;
        } else {
          result += ` / ${item.label}`;
        }
      });
      return result;
    }
  } catch (error) {
    return `Doesn't Matter`;
  }
};

const getMatchResult = (preference, profile) => {
  try {
    if (preference.length === 0) {
      return <strong className="label label-success">Match</strong>;
    } else {
      if (findIndex(preference, item => item.value === profile) === -1) {
        return <strong className="label label-danger">No Match</strong>;
      } else {
        return <strong className="label label-success">Match</strong>;
      }
    }
  } catch (error) {
    return <strong className="label label-success">Match</strong>;
  }
};
const PreferenceStat = ({ label, memberPreference, userProfile }) => {
  return (
    <tr>
      <td>{label}</td>
      <td>
        <strong>{getListOfValues(memberPreference)}</strong>
      </td>
      <td>{getMatchResult(memberPreference, userProfile)}</td>
    </tr>
  );
};

export default PreferenceStat;



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/PreferenceMatch/PreferenceStat/index.js